import {
  BadgeCent,
  BadgeDollarSign,
  Blocks,
  EarthLock,
  FilePlus2,
  Library,
  ListPlus,
  Package,
  Scroll,
  Signature,
  Split,
} from "lucide-react";
import MainContainer from "../../components/container/MainContainer";
import TransactionGridItem from "../../components/container/TransactionGridItem";
import TransactionGridContainer from "../../components/container/TransactionGridContainer";
import { openModal } from "../../features/modalSLice";
import { useDispatch, useSelector } from "react-redux";
import AddAccount from "../chart/AddAccount";
import AddCategory from "../chart/AddCategory";
import Modal from "../../components/modal/Modal";

const Maintenance = () => {
  const dispatch = useDispatch();
  const modalContent = useSelector((state) => state.modal.content);

  const openAddAccountModal = (e) => {
    dispatch(openModal(<AddAccount />));
  };

  const openAddCategoryModal = (e) => {
    dispatch(openModal(<AddCategory />));
  };
  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <div>
        <h3 className="text-text-1/80">Settings</h3>
        <TransactionGridContainer title="Chart of Account">
          <TransactionGridItem
            component={Blocks}
            title="Accounts"
            link="/settings/accounts"
          />
          <TransactionGridItem
            component={BadgeCent}
            title="Categories"
            link="/settings/account-categories"
          />
          <TransactionGridItem
            component={ListPlus}
            action={openAddCategoryModal}
            title="Add Category"
          />
          <TransactionGridItem
            component={Blocks}
            title="Add Account"
            action={openAddAccountModal}
          />
        </TransactionGridContainer>
        <TransactionGridContainer title="Currencies & Transaction Types">
          <TransactionGridItem
            component={Package}
            title="Currencies"
            link="/settings/currencies"
          />
          <TransactionGridItem
            component={EarthLock}
            title="Method Types"
            link="/settings/method-types"
          />
        </TransactionGridContainer>
        <TransactionGridContainer title="Others (Coming Soon)">
          <TransactionGridItem
            title="Bank Recon"
            component={BadgeCent}
            link="/accounts/bank-reconciliation"
          />
          <TransactionGridItem
            title="Cont Award"
            component={Signature}
            link="/accounts/contract-award"
          />
          <TransactionGridItem
            title="Currency Settings"
            component={BadgeDollarSign}
            link="/accounts/currency-settings"
          />
          <TransactionGridItem
            title="Disbursement Ctrl"
            component={Split}
            link="/accounts/disbursement-control"
          />
          <TransactionGridItem
            title="Ledger Recon"
            component={Library}
            link="/accounts/ledger-reconciliation"
          />
          <TransactionGridItem
            title="Create Vendor"
            component={FilePlus2}
            link="/vendors/create-vendor"
          />
        </TransactionGridContainer>
      </div>
    </MainContainer>
  );
};

export default Maintenance;
